// MahnungenDrawerContent — Drilldown fuer Eigene-Mahnstufen-Tile.
//
// SEMANTIK-KORREKTUR (Bug A6, 2026-05-21): Liste sind UNSERE Forderungen
// im Mahnlauf gegen unsere KUNDEN — nicht Lieferanten-Mahnungen gegen uns.
// Aktionen (Mark-Resolved/Disput) sind Sprint-7-Plus, hier nur Liste.

import type { MahnungenEingegangenResponse } from "../../../lib/api";
import { formatEUR } from "../../../lib/api";
import MahnungEingegangenCard from "../../cards/MahnungEingegangenCard";

interface Props {
  data?: MahnungenEingegangenResponse | null;
  loading?: boolean;
}

export default function MahnungenDrawerContent({ data, loading }: Props) {
  return (
    <>
      <section className="flex items-baseline justify-between text-xs text-slate-300 border border-slate-700/60 rounded-lg px-3 py-2">
        <span>{data?.n_offen ?? 0} eigene Forderungen im Mahnlauf</span>
        <span className="text-pink-300 tabular-nums font-semibold">
          {data?.total_offen_eur ? formatEUR(data.total_offen_eur) : "—"}
        </span>
      </section>

      <section className="rounded-lg border border-amber-500/30 bg-amber-500/5 px-3 py-2 text-[11px] text-amber-200">
        <strong>Hinweis:</strong> Diese Liste zeigt UNSERE Mahnstufen
        (offene Forderungen, in denen wir mahnen). Lieferanten-Mahnungen
        gegen uns kommen aus einer separaten Pipeline (E-Mail-Daemon /
        mahnung_eingegangen-DB) — noch nicht angebunden.
      </section>

      <div className="rounded-xl border border-slate-700/60 bg-slate-950/60 p-3">
        <MahnungEingegangenCard data={data ?? undefined} loading={loading} />
      </div>

      <section className="rounded-xl border border-slate-700/60 bg-slate-950/40 p-3">
        <div className="text-[11px] uppercase tracking-widest opacity-60 mb-1">
          Aktionen
        </div>
        <p className="text-[11px] text-slate-400">
          Mark-Resolved / Disput-Workflow folgt in Sprint 7+ (Mail-Outbound an
          Glaeubiger als Draft, Kevin-Freigabe Pflicht — kein Auto-Versand).
        </p>
      </section>
    </>
  );
}
